import React, { FC, ReactElement, useMemo, useRef } from 'react';
import moment from 'moment';
import Swiper from 'react-id-swiper';
import './Item.sass';
import User from './User';
import { goNext, goPrev } from '../../../../../helpers/swiper';
import Icon from '../../../../Icon';
import localeFieldResolver from '../../../../../helpers/locale-field-finder';
import { internalizationState, ParamsDto } from '../../../../../stores/reducers/sections';
import { useSelector } from 'react-redux';
interface Props {
  data: EpisodeDto;
  isVertical: boolean;
  sectionData?: Array<ParamsDto>
}

interface ILocaleData {
  info_ru: string;
  name_ru: string;
  info_en: string;
  name_en: string;
}
export interface EpisodeDto extends ILocaleData {
  id: number;
  moderators: any[];
  speakers: any[];
  timeStart: number;
  timeStop: number;
  color: string;
}

const Item: FC<Props> = ({ data: { id, moderators, speakers, timeStart, timeStop, color, ...localeData}, isVertical, sectionData }): ReactElement => {
  const swiperParams = {
    watchOverflow: true,
    slidesPerView: isVertical ? 'auto' as 'auto' : 3,
    spaceBetween: 16,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    freeMode: true,
    freeModeSticky: true,
    direction: isVertical ? 'vertical' as 'vertical' : 'horizontal' as 'horizontal',
  };

  const swiperRef = useRef(null);

  const {activeLangState} = useSelector(internalizationState);
  const localizeData = {
    moderator_ru: 'Модератор',
    moderator_en: 'Moderator',
    speaker_ru: 'Спикер',
    speaker_en: 'Speaker',
  };

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);

  const timeStamp = useMemo(() => {
    const mask = 'HH:mm';
    const start = moment.unix(timeStart).format(mask);
    const end = moment.unix(timeStop).format(mask);

    return `${start}-${end}`;
  }, [timeStart, timeStop]);

  const userSlides = useMemo(() => {
    let slides: ReactElement[] = [];
    if (moderators) {
      slides = [
        ...slides,
        ...moderators.map((user) => (
          <div className="swiper-slide" key={user.id}>
            <User name={localizedName('moderator_ru')} key={user.id} data={user} />
          </div>
        )),
      ];
    }
    if (speakers) {
      slides = [
        ...slides,
        ...speakers.map((user) => (
          <div className="swiper-slide" key={user.id} style={{padding: '0 16px'}}>
            <User name={localizedName('speaker_ru')} key={user.id} data={user} />
          </div>
        )),
      ];
    }

    return slides;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moderators, speakers]);

  const itemBackground = sectionData?.find((item) => item.key === 'scheduleItemBackground');
  
  return (
    <li className="schedule-item" data-id={id}>
      <div className="schedule-info-line" style={{ backgroundColor: `#${color}` }}>
        <span className="schedule-info-line__time">{timeStamp}</span>
        {/* <span className="label-info label-info--mcolor">Экономика</span> */}
        {/* <span className="label-info label-info--primary">primary label</span> */}
      </div>
      <div className="schedule-inner" style={{backgroundColor: itemBackground ? itemBackground.value : ''}}>
        <div className="schedule-title">
          <h2 className="f-main">{localeFieldResolver(localeData, 'name_ru', activeLangState)}</h2>
        </div>
        <div className="user-list-wrapper" style={{ paddingLeft: 16 + 'px' }}>
          <ul className="user-list">
            <Swiper ref={swiperRef} {...swiperParams} rebuildOnUpdate={true}>
              {userSlides}
            </Swiper>
            {(((moderators && moderators.length > 3) || (speakers && speakers.length > 3)) && !isVertical) && (
              <div className="slider-nav hidden-mobile">
                <button className="slider-nav__prev" type="button" style={{transform: 'translateX(-16px)'}} onClick={() => goPrev(swiperRef)}>
                  <Icon name="md-arr-left" />
                </button>
                <button className="slider-nav__next" type="button" onClick={() => goNext(swiperRef)}>
                  <Icon name="md-arr-right" />
                </button>
              </div>
            )}
          </ul>
        </div>
        {/* <div className="schedule-btns hidden-mobile"> */}
        {/*  <a className="btn btn-primary btn--sm" href="#test"> */}
        {/*    Смотреть запись */}
        {/*  </a> */}
        {/*  <a className="btn btn--text btn--sm" href="#test"> */}
        {/*    Подробнее */}
        {/*  </a> */}
        {/* </div> */}
      </div>
    </li>
  );
};

export default Item;
